/**
 * Created by mateo on 5/28/17.
 */
export class Item {
    public id: string;
    public label: string;
    public childs: Array<Item>;
    public parent: Item;
    public visible: boolean = true;

    public selected: boolean;

    public constructor(item: any) {
        if (typeof item == 'object') {
            this.id = item.id;
            this.label = item.label;
            this.selected = item.selected || false;
            this.visible = item.visible || true;
            if (item.childs && item.label) {
                this.childs = item.childs.map((child: any) => {
                    let cChild:Item = new Item(child);
                    cChild.parent = this;
                    return cChild
                });
                this.label = item.label;
            }
        }
    }

    public isParent(): boolean{
        return typeof(this.parent) == 'undefined';
    }
}
